import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../views/login/login.vue";
import allReady from "../views/supplier/all_ready";
import guest from './middlewares/guest'
import auth from './middlewares/auth'
import middlewarePipeline from './middlewares/middlewarepipeline'
import store from "../store";

// Login
import home from "../views/index/index";
import ForgotPassword from "../views/login/forgot-password";
import NewPassword from "../views/login/new-password";
import ErrorConfigEntity from "../views/index/error-config-entity.vue";
import StatusMessage from "../components/layouts/status-message.vue";
import blockingPassword from "../views/login/blocking_password.vue";

// Alers
import Alert from "../views/alert/alert.vue";


// Supplier Management
import FirstInfoLayer from "../views/terms/first-info-layer.vue"
import CompanyData from "../views/supplier/company_data";
import AccessData from "../views/supplier/access_data";
import ConfirmationData from "../views/supplier/confirmation_data.vue";
import SupplierManagement from "../views/supplier/supplier_management.vue";
import SupplierManagementConfirmation from "../views/supplier/supplier_management_confirm.vue";

// Accounts
import AccountManagement from "../views/accounts/account_management.vue";
import AddAccount from "../views/accounts/add_account.vue";
import ConfirmAccount from "../views/accounts/confirm_account.vue";
import ConfirmAccountEdit from "../views/accounts/confirm_account_edit.vue";

import AccountEdit from "../views/accounts/edit_account.vue";




// Users
import UserManagement from "../views/users/user_management.vue";
import UserConfirmation from "../views/users/user_confirmation.vue";
import UserManagementProfile from "../views/users/user_profile.vue";
import AddUser from "../views/users/add_user.vue";
import UserManagementConfirm from "../views/users/add_user_confirm.vue";

// Invoices
import InvoicesMain from "../views/invoices/invoices.vue";
import InvoiceAdvance from "../views/invoices/invoice_advance.vue";
import InvoiceAdvanceConfirm from "../views/invoices/invoice_advance_simulation.vue";
import LiquidationSimulation from "../views/invoices/liquidation_simulation.vue";
import AddAutomaticAdvance from "../views/invoices/add_autoadvance.vue";
import RemoveAutomaticAdvance from "../views/invoices/remove_autoadvance.vue";
import QueryAutomaticAdvance from "../views/invoices/invoice_advance_query.vue";
import AddAutomaticAdvanceConfirm from "../views/invoices/confirm_create_autoadvance.vue";
import RemoveAutomaticAdvanceConfirm from "../views/invoices/confirm_remove_autoadvance.vue";
import EditAutomaticAdvanceConfirm from "../views/invoices/confirm_edit_autoadvance.vue";

Vue.use(VueRouter);

const routes = [{
  path: "/",
  name: "Login",
  component: Login,
  meta: {
    middleware: [
      guest
    ]
  }
},
{
  path: "/forgot-password",
  name: "ForgotPassword",
  component: ForgotPassword,
  meta: {
    middleware: [
      guest
    ]
  }
},
{
  path: "/new-password",
  name: "newPassword",
  component: NewPassword,
  meta: {
    middleware: [
      guest
    ]
  }
},
{
  path: "/first-info-layer",
  name: "FirstInfoLayer",
  component: FirstInfoLayer,
  meta: {
    middleware: [
      guest
    ]
  }
},

{
  path: "/confirmation-data",
  name: "ConfirmationData",
  component: ConfirmationData,
  meta: {
    middleware: [
      guest
    ]
  }
},
{
  path: "/company-data",
  name: "CompanyData",
  component: CompanyData,
  props: true,
  meta: {
    middleware: [
      guest
    ]
  }
},

{
  path: "/access-data",
  name: "AccessData",
  component: AccessData,
  props: true,
  meta: {
    middleware: [
      guest
    ]
  }
},

{
  path: "/ready",
  name: "allReady",
  component: allReady,
  meta: {
    middleware: [
      guest
    ]
  }

},


{
  path: "/alert",
  name: "alert",
  component: Alert,
  meta: {
    middleware: [
      auth
    ]
  },

},

{
  path: "/blockingPassword",
  name: "blockingPassword",
  component: blockingPassword,
  meta: {
    middleware: [
      guest
    ]
  }

},


{
  path: "/user-confirmation",
  name: "UserConfirmation",
  component: UserConfirmation,
  meta: {
    middleware: [
      guest
    ]
  }

},
{
  path: "/home",
  name: "home",
  component: home,
  meta: {
    middleware: [
      auth
    ]
  }
},
{
  path: "/status-message",
  name: "StatusMessage",
  component: StatusMessage,
  meta: {
    middleware: [
      auth
    ]
  }
},
{
  path: "/gestion-de-proveedores",
  name: "SupplierManagement",
  component: SupplierManagement,
  meta: {
    middleware: [
      auth
    ]
  },
},
{
  path: "/gestion-de-proveedores/confirmar",
  name: "SupplierManagementConfirmation",
  component: SupplierManagementConfirmation,
  meta: {
    middleware: [
      auth
    ]
  },
},

{
  path: "/liquidacion-simulacion",
  name: "LiquidationSimulation",
  component: LiquidationSimulation,
  meta: {
    middleware: [
      auth
    ]
  },
},

{
  path: "/cuentas-de-abono",
  name: "AccountManagement",
  component: AccountManagement,
  meta: {
    middleware: [
      auth
    ]
  },
},
{
  path: "/cuentas-de-abono/alta",
  name: "AddAccount",
  component: AddAccount,
  meta: {
    middleware: [
      auth
    ]
  },
},
{
  path: "/cuentas-de-abono/confirmar",
  name: "ConfirmAccount",
  component: ConfirmAccount,
  meta: {
    middleware: [
      auth
    ]
  },
},

{
  path: "/cuentas-de-abono/account-edit",
  name: "AccountEdit",
  component: AccountEdit,
  meta: {
    middleware: [
      auth
    ]
  },
},

{
  path: "/cuentas-de-abono/confirmar/edit",
  name: "ConfirmAccountEdit",
  component: ConfirmAccountEdit,
  meta: {
    middleware: [
      auth
    ]
  },
},

{
  path: "/gestion-de-usuarios",
  name: "UserManagement",
  component: UserManagement,
  meta: {
    middleware: [
      auth
    ]
  },
},
{
  path: "/gestion-de-usuarios/perfil",
  name: "UserManagementProfile",
  component: UserManagementProfile,
  meta: {
    middleware: [
      auth
    ]
  },
},
{
  path: "/gestion-de-usuarios/add",
  name: "UserManagementAdd",
  component: AddUser,
  meta: {
    middleware: [
      auth
    ]
  },
},
{
  path: "/gestion-de-usuarios/confirm",
  name: "UserManagementConfirm",
  component: UserManagementConfirm,
  meta: {
    middleware: [
      auth
    ]
  },
},
{
  path: "/facturas",
  name: "InvoicesMain",
  component: InvoicesMain,
  meta: {
    middleware: [
      auth
    ]
  },
},
{
  path: "/anticipo-facturas",
  name: "InvoiceAdvance",
  component: InvoiceAdvance,
  meta: {
    middleware: [
      auth
    ]
  },
},
{
  path: "/anticipo-facturas/confirmar",
  name: "InvoiceAdvanceConfirm",
  component: InvoiceAdvanceConfirm,
  meta: {
    middleware: [
      auth
    ]
  },
},
{
  path: "/anticipo-automatico",
  name: "AutomaticAdvance",
  component: AddAutomaticAdvance,
  meta: {
    middleware: [
      auth
    ]
  },
},
{
  path: "/anticipo-automatico/alta/confirmar",
  name: "AddAutomaticAdvanceConfirm",
  component: AddAutomaticAdvanceConfirm,
  meta: {
    middleware: [
      auth
    ]
  },
},
{
  path: "/anticipo-automatico/baja",
  name: "RemoveAutomaticAdvance",
  component: RemoveAutomaticAdvance,
  meta: {
    middleware: [
      auth
    ]
  },
},
{
  path: "/anticipo-automatico/baja/confirmar",
  name: "RemoveAutomaticAdvanceConfirm",
  component: RemoveAutomaticAdvanceConfirm,
  meta: {
    middleware: [
      auth
    ]
  },
},
{
  path: "/anticipo-automatico/consulta",
  name: "QueryAutomaticAdvance",
  component: QueryAutomaticAdvance,
  meta: {
    middleware: [
      auth
    ]
  },
},
{
  path: "/anticipo-automatico/modificacion/confirmar",
  name: "EditAutomaticAdvanceConfirm",
  component: EditAutomaticAdvanceConfirm,
  meta: {
    middleware: [
      auth
    ]
  },
},
{
  path: "/error/configuracion_de_entidad",
  name: "ErrorConfigEntity",
  component: ErrorConfigEntity,
},
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.name != "ErrorConfigEntity") {
    store.dispatch('entityConfig/setEntityConfiguration')
  }
  if (!to.meta.middleware) {
    return next()
  }
  const middleware = to.meta.middleware

  const context = {
    to,
    from,
    next,
  }


  return middleware[0]({
    ...context,
    next: middlewarePipeline(context, middleware, 1)
  })

})

export default router;